/* eslint-disable @typescript-eslint/naming-convention */
export enum DatePickerHourCycleTypeEnum {
	H12 = 'h12',
	H24 = 'h23'
}
